module.exports = __webpack_public_path__ + "img/dominica.d57c465f.png";